import React, { useState } from 'react';

import Lightbox from 'components/shared/Lightbox';
import { MEDIA_TYPE, Media } from 'constants/types';

import Tags from './components/Tags';
import TopicContent from './components/TopicContent';
import TopicMedia from './components/TopicMedia';
import {
  BodyContainer,
  MediaGridContainer,
  MediaItem,
  Overlay,
  OverlayText,
} from './styles';

interface TopicBodyProps {
  title: string;
  content: string;
  tags: string[];
  medias: Media[];
}

const TopicBody: React.FC<TopicBodyProps> = ({
  title,
  content,
  medias,
  tags,
}) => {
  const displayedMedias = medias.slice(0, 4);
  const totalMediaCount = medias.length;

  const [showLightbox, setShowLightbox] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => {
    setCurrentIndex(index);
    setShowLightbox(true);
  };

  const closeLightbox = () => {
    setShowLightbox(false);
    setCurrentIndex(null);
  };

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === displayedMedias.length - 1 ? 0 : prevIndex! + 1,
    );
  };

  const handlePreviousImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? displayedMedias.length - 1 : prevIndex! - 1,
    );
  };

  return (
    <BodyContainer>
      <TopicContent title={title} content={content} />
      <Tags tags={tags} />
      {displayedMedias.length > 0 && (
        <MediaGridContainer itemCount={displayedMedias.length}>
          {displayedMedias.map((media, index) => (
            <MediaItem key={media._id}>
              <TopicMedia
                alt={media.originalname}
                mediaType={media.mediaType}
                fileName={media.filename}
                onClick={() => openLightbox(index)}
              />
              {index === 3 && totalMediaCount > 4 && (
                <Overlay onClick={() => openLightbox(0)}>
                  <OverlayText>{`+${totalMediaCount - 4}`}</OverlayText>
                </Overlay>
              )}
            </MediaItem>
          ))}
        </MediaGridContainer>
      )}
      {showLightbox && currentIndex !== null && (
        <Lightbox
          mediaUrl={
            medias[currentIndex].mediaType === MEDIA_TYPE.IMAGE
              ? `${process.env.REACT_APP_BACKEND_FORUM_URL}/medias/images/${medias[currentIndex].filename}`
              : `${process.env.REACT_APP_BACKEND_FORUM_URL}/medias/videos/${medias[currentIndex].filename}`
          }
          isVideo={medias[currentIndex].mediaType === MEDIA_TYPE.VIDEO}
          onClose={closeLightbox}
          onNext={handleNextImage}
          onPrevious={handlePreviousImage}
          totalMediaCount={displayedMedias.length}
        />
      )}
    </BodyContainer>
  );
};

export default TopicBody;
